import React from "react";
export function AutoNoShowControl({ autoNoShowEnabled = false, setAutoNoShowEnabled = () => {} }) {
  return <button type="button" aria-pressed={autoNoShowEnabled}
    onClick={() => setAutoNoShowEnabled(previous => !previous)}>
    Auto No-Show: {autoNoShowEnabled ? 'ON' : 'OFF'}
  </button>;
}
export default function PlannerAlerts({ noShowAlerts = [], lateShiftAlerts = [], autoNoShowCandidates = [] }) {
  return <>
    {noShowAlerts.length > 0 && <p role="status" className="schedule-exception">No Show Alert — {noShowAlerts.length} shift{noShowAlerts.length === 1 ? '' : 's'} need attention</p>}
    {lateShiftAlerts.length > 0 && <p role="status" className="schedule-exception is-warning">Late Worker Alert — {lateShiftAlerts.length} shift{lateShiftAlerts.length === 1 ? '' : 's'} need attention</p>}
    {autoNoShowCandidates.length > 0 && <p role="status" className="schedule-exception">Auto No-Show Candidates — {autoNoShowCandidates.length} shift{autoNoShowCandidates.length === 1 ? '' : 's'} are 30+ minutes late</p>}
  </>;
}
